<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4 class="card-header-title">Danh sách trợ cấp</h4>
          </div>
          <div class="text-right">
            <div>
              <el-button
                v-if="aRole('AdminSystem')"
                @click="fn_tableShowFormSearch()"
                type="info"
                round
                class="btn-default"
                >Ẩn/hiện tìm kiếm</el-button
              >
              <el-button
                round
                class="btn-default"
                @click="fn_handle('create')"
                v-if="mData.dataDefault.listFeature.includes('FT502')"
                >Thêm mới</el-button
              >
            </div>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-search">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="mb-3"
            >
              <b-card>
                <el-form
                  ref="mySearchForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="120px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Tên trợ cấp">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value.name"
                          clearable
                          placeholder=""
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Công ty">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value.company_id"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listCompany"
                            :key="item.id"
                            :label="item.name.name_vi"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Trạng thái khóa">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value.disabled"
                          clearable
                          placeholder=""
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listTrangThaiKhoa"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      round
                      native-type="submit"
                      class="btn-default"
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="main-body-table">
            <el-table
              :data="mData.tableRules.data"
              border
              @sort-change="fn_tableSortChange"
              style="width: 100%"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1]
              }"
            >
              <el-table-column
                type="selection"
                width="40"
                v-if="mData.tableRules.allowSelect"
              ></el-table-column>

              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="code"
                label="Mã trợ cấp"
                min-width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="Tên trợ cấp"
                min-width="250"
              ></el-table-column>
              <el-table-column
                v-if="aRole('AdminSystem')"
                prop="company_name"
                label="Tên công ty"
                min-width="250"
              ></el-table-column>
              <el-table-column label="Khóa" width="75" align="center">
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.disabled"
                    @change="
                      fn_changeTrangThaiKhoa(scope.row.id, scope.row.disabled)
                    "
                    :disabled="
                      !mData.dataDefault.listFeature.includes('FT504') ||
                        (aRole('Customer') && !scope.row.company_id)
                    "
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                label="Thao tác"
                align="center"
                width="120px"
                v-if="
                  mData.dataDefault.listFeature.includes('FT504') ||
                    mData.dataDefault.listFeature.includes('FT503')
                "
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    round
                    @click="fn_handle('update', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_update"
                    type="primary"
                    v-if="mData.dataDefault.listFeature.includes('FT504')"
                    :disabled="
                      !mData.dataDefault.listFeature.includes('FT504') ||
                        (aRole('Customer') && !scope.row.company_id)
                    "
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    round
                    @click="fn_handle('delete', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_delete"
                    type="danger"
                    v-if="mData.dataDefault.listFeature.includes('FT503')"
                    :disabled="
                      !mData.dataDefault.listFeature.includes('FT503') ||
                        (aRole('Customer') && !scope.row.company_id)
                    "
                  >
                    <i class="fas fa-trash-alt"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
              <div class="col-md-4">
                <div v-if="mData.tableRules.allowSelect">
                  {{ aLang.c_select }}:
                  {{ mData.tableRules.recordSelected.length }}
                </div>
              </div>
              <div class="col-md-8 text-right">
                <el-pagination
                  @size-change="fn_tableSizeChange"
                  @current-change="fn_tableCurentChange"
                  @prev-click="fn_tablePrevClick"
                  @next-click="fn_tableNextClick"
                  :page-sizes="mData.tableRules.lengthMenu"
                  :page-size="mData.tableRules.limit"
                  :current-page="mData.tableRules.page"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="mData.tableRules.total"
                  :pager-count="5"
                ></el-pagination>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="
        mData.viewMode == 'create' ? 'Thêm mới trợ cấp' : 'Cập nhật trợ cấp'
      "
      :visible.sync="formDialog"
      width="60%"
      :before-close="fn_resetForm"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          @submit.native.prevent
          ref="myForm"
          label-width="160px"
          label-position="top"
          v-if="formDialog"
        >
          <b-row class="mb-1">
            <b-col md="4" v-if="aRole('AdminSystem')">
              <el-form-item label="Tên công ty" prop="company_id1">
                <el-select
                  @input="forceUpdateUI"
                  v-model="mData.dataForm.company_id"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.viewMode == 'create'
                      ? mData.dataDefault.listCompany
                      : mData.dataDefault.listCompanyUpdate"
                    :key="item.id"
                    :label="item.name.name_vi"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col :md="aRole('AdminSystem') ? '4' : '6'">
              <el-form-item label="Mã trợ cấp" prop="code">
                <el-input
                  @input="forceUpdateUI"
                  type="text"
                  v-model.trim="mData.dataForm.code"
                  @change="() => {mData.dataForm.code = mData.dataForm.code.toUpperCase()}"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col :md="aRole('AdminSystem') ? '4' : '6'">
              <el-form-item label="Tên trợ cấp" prop="name">
                <el-input
                  @input="forceUpdateUI"
                  type="text"
                  v-model="mData.dataForm.name"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <div class="text-center mt-2">
            <el-button
              round
              class="btn-default"
              @click="fn_submitForm('create')"
              v-if="mData.viewMode == 'create'"
              native-type="submit"
              >Lưu</el-button
            >
            <el-button
              round
              class="btn-default"
              @click="fn_submitForm('update')"
              v-if="mData.viewMode == 'update'"
              native-type="submit"
              >Cập nhật</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
// import ExtensionService from "../../../service/ExtensionService";
import CategoryModel from "../GeneralDirector/CategoryModel";
import SubsidiesSalaryTypeApi from "../../../moduleApi/SubsidiesSalaryTypeApi";
import CompanyApi from "../../../moduleApi/CompanyApi";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      formDialog: false,
      mData: {
        id: null,
        viewMode: "create",
        moduleName: "SubsidiesSalaryType", //requied
        dataForm: MethodService.copyObject(CategoryModel.dataForm),
        validForm: CategoryModel.validForm,
        tableRules: MethodService.copyObject(CategoryModel.tableRules),
        dataDefault: {
          listCompany: [],
          listCompanyUpdate: [],
          listFeature: MethodService.getListFeatures(),
          listTrangThaiKhoa: DataService.listTrangThaiKhoa
        },
        currentUser: MethodService.getCurrentUser(),
        companyInfo: {}
      }
    };
  },

  methods: {
    async fn_innitDataDefault() {},
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = "company_id";
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: "company_id",
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch
            }
          })
          .catch(err => {});
      }
      let res = await SubsidiesSalaryTypeApi.list(dataFilter);
      this.mData.tableRules.total = res.meta.total;
      if (res.result && res.result.length > 0) {
        let resData = await this.fn_changeData(res.result);
        this.mData.tableRules.page =
          this.mData.tableRules.offset / this.mData.tableRules.limit + 1;
        await this.fn_reRender(resData);
      } else {
        this.mData.tableRules.data = [];
        if (
            this.mData.tableRules.offset == this.mData.tableRules.total &&
            this.mData.tableRules.page > 1
        ) {
            this.mData.tableRules.page = this.mData.tableRules.page - 1;
            this.mData.tableRules.offset =
              (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
            await this.fn_initTable();
        }
      }
    },
    fn_reRender(resData) {
      this.mData.tableRules.data = resData;
      if (
        this.mData.tableRules.offset == this.mData.tableRules.total &&
        this.mData.tableRules.page > 1
      ) {
        this.mData.tableRules.page = this.mData.tableRules.page - 1;
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
          this.fn_initTable();
      }
    },
    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      if (this.mData.currentUser.roles.includes("AdminSystem")) {
        const companyRes = await CompanyApi.list({ limit: 9999999 });
        const companyApiUpdateRes = await CompanyApi.list({ filters: "disabled=false", limit: 9999999 });
        this.mData.dataDefault.listCompany = companyApiUpdateRes.result;
        this.mData.dataDefault.listCompanyUpdate = companyRes.result;
        // this.mData.dataDefault.listCompany.unshift({
        //     id: "system",
        //     name:{
        //         name_vi: "Hệ thống"
        //     }
        // })
      } else if (this.mData.currentUser.roles.includes("Customer")) {
        this.mData.companyInfo = MethodService.getCompanyInfo();
        this.mData.dataDefault.listCompanyUpdate = [];
        this.mData.dataDefault.listCompanyUpdate.push(this.mData.companyInfo);
      }
      resData.forEach(item => {
        if (item.code) {
          item.code = item.code.toUpperCase();
        }
        let congTy = this.mData.dataDefault.listCompanyUpdate.find(element => {
          return element.id == item.company_id;
        });
        if (congTy && congTy.name && congTy.name.name_vi) {
          item.company_name = congTy.name.name_vi;
        } else {
          item.company_name = " ";
        }
      });
      return resData;
    },
    //search
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value.name) {
        this.mData.tableRules.dataSearch.value.name = this.mData.tableRules.dataSearch.value.name.trim();
      }

      this.$refs["mySearchForm"].validate(async valid => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.filters = this.mData.tableRules.filters.replace(
            "company_id=system",
            "company_id:is_null:true"
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    //event table
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },
    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
    async fn_changeTrangThaiKhoa(id, trangThai) {
      let data = {
        id: id,
        disabled: trangThai
      };
      try {
        await SubsidiesSalaryTypeApi.update(data);
      } catch (error) {
        console.log(error);
      }
    },
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.mData.viewMode = "create";
        this.formDialog = true;
      }
      if (type == "update") {
        this.mData.id = row.id;
        this.fn_getDataById(row.id);
        this.mData.viewMode = "update";
        this.formDialog = true;
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },
    async fn_delete(id) {
      try {
        await SubsidiesSalaryTypeApi.delete(id);
        await this.fn_initTable();
        this.mData.viewMode = "create";
      } catch (error) {
        if (error && error.code && error.code === 500) {
          window.toastr.error(error.detail);
        } else {
          window.toastr.error("Xóa thất bại");
        }
      }
    },

    //Form
    async fn_getDataById(id) {
      let res = await SubsidiesSalaryTypeApi.findById(id);
      if (res.result) {
        this.mData.dataForm = res.result;
      }
    },
    fn_submitForm(type) {
      if (this.mData.dataForm.name) {
        this.mData.dataForm.name = this.mData.dataForm.name.trim();
      }
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          let data = this.mData.dataForm;
          if (this.aRole("Customer")) {
            data.company_id = this.mData.companyInfo.id;
          }
          if (data.company_id == "") {
            data.company_id = null;
          }
          try {
            if (type == "create") {
              await SubsidiesSalaryTypeApi.create(data);
              this.fn_initTable();
              this.fn_resetForm();
              this.mData.viewMode = "create";
            } else if (type == "update") {
              data.id = this.mData.id;
              await SubsidiesSalaryTypeApi.update(data);
              this.fn_initTable();
              this.fn_resetForm();
              this.mData.viewMode = "create";
            }
          } catch (error) {
            if (error && error.code === 500) {
              window.toastr.error("Mã trợ cấp bị trùng");
            } else {
              if (type == "create") {
                window.toastr.error("Thêm mới không thành công");
              } else if (type == "update") {
                window.toastr.error("Cập nhật thất bại");
              }
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.formDialog = false;
      this.mData.dataForm = MethodService.copyObject(CategoryModel.dataForm);
      this.$refs["myForm"].resetFields();
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }

      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        )
        let m1 = this.mData.tableRules.filters.match(/\$vn_text=([^&]*)(&|$)/);
        if (m1) {
          this.$set(this.mData.tableRules.dataSearch.value, 'name', decodeURIComponent(m1[1]));
        }
      }
    },
  },

  //run after render view
  async created() {
    await this.fn_hashUrl();
    await this.fn_initTable();
  },
};
</script>
